import React, { useEffect, useRef, useState } from "react";
import NavBar from "../../Components/Navbar/navbar";
import { useLocation, useNavigate } from "react-router";
import styles from "../Styles/tables.module.css";
import { Url, getUser } from "../../Constants/globals";
import { TbArrowBigLeftFilled, TbArrowBigRightFilled, TbArrowBigRightLinesFilled, TbArrowBigLeftLinesFilled } from "react-icons/tb";
import axios from "axios";
import RefreshToken from "../../Components/RefreshToken/RefreshToken";
import { HiPencil, HiPlus, HiTrash, HiSearch, HiX, HiBell } from "react-icons/hi";
import { HiOutlineMegaphone } from "react-icons/hi2";
import DeleteModal from "../../Components/DeleteModal/deletemodal";
import Alert from "../../Components/Alert/alert";
import stylesModal from "../../Components/DeleteModal/deletemodal.module.css";
import Loading from "../../Components/Loading/loading";

function Modal({id, closeModal, setAlert, setLoading, warningText, fetchData}) {

  const [isPoppedOut, setIsPoppedOut] = useState(false);

  async function notify() {
    await setAlert("");
    await setLoading(<Loading/>);
    try {
      await axios.post(`${Url}/notify-campaigns/${id}`, {}, {
        headers: {
          Authorization: "Bearer " + getUser().token,
        },
      });
      await fetchData();
      await setLoading("");
      await handleClose();
      return setAlert(<Alert type={"success"}>Utilizadores notificados com sucesso</Alert>)
    }
    catch (err) {
      if (err.request && err.request.status === 401){
        var newToken = await RefreshToken(err);
        if (newToken) {
          return await notify();
        } else {
          window.location.reload();
        }
      }
      else {
        console.error(err);
        setLoading("");
        return  setAlert(<Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao notificar os utilizadores"}</Alert>);
      }
    };
  }

  function handleClose() {
    setIsPoppedOut(true);
    setTimeout(() => {
      closeModal("");
    }, 250);
  }

  return (
    <div className={`${stylesModal.bodyDelete} ${isPoppedOut ? stylesModal.popout : stylesModal.popin}`}>
      <div className={stylesModal.center}>
        <div className={stylesModal.column}>
          <h4 style={{margin:0}}>Deseja notificar todos os colaboradores?</h4>
          {
            warningText ?
              <p style={{color: "red", fontSize: "11pt", marginTop: "10px"}}>{warningText}</p>
            :""
          }
          <div className={stylesModal.buttons}>
            <button className={stylesModal.actionButton} onClick={() => notify()}>{warningText ? "Notificar novamente" : "Notificar"}</button>
            <button className={stylesModal.backButton} onClick={() => handleClose()}>Regressar</button>
          </div>
        </div>
      </div>
    </div>
  );
}

async function deleteCampaignFunction(id){
  try {
    await axios.delete(`${Url}/campaigns/${id}`, {
      headers: {
        Authorization: "Bearer " + getUser().token,
      },
    });
    return [200, <Alert type={"success"}>Campanha eliminada com sucesso!</Alert>];
  }
  catch (err) {
    if (err.request && err.request.status === 401){
      var newToken = await RefreshToken(err);
      if (newToken) return await deleteCampaignFunction(id);
      else window.location.reload();
    }
    else {
      console.error(err);
      return  [0, <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao eliminar campanha"}</Alert>];
    }
  };
}

async function getCampaign(page, search){
  try {
    const res = await axios
    .get(`${Url}/campaigns?page=${page ? page : 1}${search ? "&search="+search : ""}`, {
      headers: {
        Authorization: "Bearer "+getUser().token,
      },
    });
    return res.data;
  }
  catch (err) {
    if (err.request && err.request.status === 401){
      var newToken = await RefreshToken(err);
      if (newToken) return await getCampaign(page, search);
      else window.location.reload();
    }
    else {
      console.error(err);
      return [];
    }
  };
}

function Campanhas({userPermissions}) {

  const location = useLocation();
  const { state } = location;
  const navigate = useNavigate();
  const [notifModal, setNotifModal] = useState("");
  const [deleteCampaign, setDeleteCampaign] = useState("");
  const [loading, setLoading] = useState("");
  const [alert, setAlert] = useState("");
  const searchRef = useRef(null);
  const [loadingData, setLoadingData] = useState(true);
  const [campaignsData, setCampaignsData] = useState([]);
  const [previousPage, setPreviousPage] = useState("");
  const [nextPage, setNextPage] = useState("");
  const [perPage, setPerPage] = useState(15);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(state?.page ? state.page : "");
  const [showSearch, setShowSearch] = useState(false);
  const [isPoppedOut, setIsPoppedOut] = useState(false);
  const [nomeSearch, setNomeSearch] = useState("");

  async function assignData() {
    const thisCampaignsData = await getCampaign(currentPage);
    setCurrentPage(thisCampaignsData.current_page);
    setNextPage(thisCampaignsData.next_page);
    setTotal(thisCampaignsData.total_items);
    setPreviousPage(thisCampaignsData.prev_page);
    setPerPage(thisCampaignsData.per_page);
    setCampaignsData(thisCampaignsData);
    setLoadingData(false);
  }

  useEffect(() => {
    assignData();
  }, []);

  async function handlePageChange(next, start) {
    if (next) {
      const newCampaignsData = await getCampaign(start ? start : nextPage, nomeSearch);
      setCampaignsData(newCampaignsData);
      setCurrentPage(newCampaignsData.current_page);
      setNextPage(newCampaignsData.next_page);
      setTotal(newCampaignsData.total_items);
      setPreviousPage(newCampaignsData.prev_page);
      setPerPage(newCampaignsData.per_page);
    }
    else if (!next && previousPage) {
      const newCampaignsData = await getCampaign(previousPage, nomeSearch);
      setCampaignsData(newCampaignsData);
      setCurrentPage(newCampaignsData.current_page);
      setNextPage(newCampaignsData.next_page);
      setTotal(newCampaignsData.total_items);
      setPreviousPage(newCampaignsData.prev_page);
      setPerPage(newCampaignsData.per_page);
    }
    else return;
  }

  const handleSearchContainer = () => {
    if (showSearch){
      setIsPoppedOut(true);
      setTimeout(() => {
        setShowSearch(false);
        setIsPoppedOut(false);
      },280);
    } else {
      setShowSearch(true);
      setTimeout(() => {
        searchRef.current.focus();
      }, 280);
    }
  }

  async function handleSearch(input) {
    if (input === false) setNomeSearch("");
    const searchCampaignsData = await getCampaign(1, input === false ? "" : nomeSearch);
    setCurrentPage(searchCampaignsData.current_page);
    setNextPage(searchCampaignsData.next_page);
    setPreviousPage(searchCampaignsData.prev_page);
    setPerPage(searchCampaignsData.per_page);
    setTotal(searchCampaignsData.total_items);
    setCampaignsData(searchCampaignsData);
  }

  async function getAlertDelete(id) {
    if (id){
      await setAlert("");
      const res = await deleteCampaignFunction(id);
      setAlert(res[1]);
      assignData();
      return res;
    }
  }

  function getLastPage(){
    const calc = total / perPage;
    const calcNoDecimals = Math.trunc(calc);
    if (calc > calcNoDecimals) return calcNoDecimals + 1;
    else return calcNoDecimals;
  }

  return (
    <div className="body">
      {loading}
      {alert}
      {notifModal}
      {deleteCampaign}
      <NavBar current={"campanhas"} setDisappear={setLoadingData} userPermissions={userPermissions} />
      {
        loadingData ? ""
        :
        <div style={{position: "relative"}}>
          <div className={styles.tableButtons}>
            <button className={styles.btnAdd} onClick={() => navigate("/campanhas/adicionar")}>
              <HiPlus size={20}/>
              <p className={styles.textAdd}>Adicionar</p>
            </button>
            <button className={`${styles.btnSearch} ${showSearch ? styles.btnSearchActive : ""}`} onClick={() => handleSearchContainer()}>
              <HiSearch size={20}/>
              <p className={styles.textAdd}>Procurar</p>
            </button>
          </div>
          <div className={styles.content}>
            {
              showSearch ?
              <div className={`${styles.container} ${showSearch ? styles.popin : ""} ${isPoppedOut ? styles.popout : ""}`}  >
                <input 
                  className={styles.searchInput}
                  ref={searchRef}
                  onChange={(e) => setNomeSearch(e.target.value)}
                  placeholder="Procurar por título"
                  value={nomeSearch}
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      handleSearch();
                    }
                  }}
                />
                <div style={{backgroundColor: "var(--inputBackground)", display: "flex", borderTopRightRadius: "4px", borderBottomRightRadius: "4px"}}>
                  <button className={styles.btn} style={{cursor: "default", marginRight: "0"}} onClick={() => handleSearch(false)}><HiX size={16} color="#9c9c9c"/></button>
                  <button className={styles.btn} style={{marginLeft: "0"}} onClick={() => handleSearch()}><HiSearch size={18}/></button>
                </div>
              </div>
              : ""
            }
            <div className={styles.table}>
              <div className={styles.campaignsColumn}>
                <p></p>
                <p>Título</p>
                <p>Mensagem</p>
                <p>Criado por</p>
                <p>Prazo</p>
                <p>Ações</p>
              </div>
              <div className={styles.scrollContent}>
                {
                  campaignsData?.items?.length > 0 ?
                    campaignsData?.items?.map((object, index) =>
                      <div key={object.id} className={styles.campaignsInfo} style={ index % 2 !== 0 ? {backgroundColor: "var(--inputBackground)"} : {}}>
                        <p style={{display: "flex", flexDirection: "column", alignItems: "center", gap: "3px"}}>
                          <HiOutlineMegaphone size={24} style={ object.is_event ? {transform: "scale(-1, 1)"} : {}} />
                          <label className={styles.iconLabel}>{object.is_event ? "Evento" : "Campanha"}</label>
                        </p>
                        <p title={object.title ? object.title : ""}>{object.title ? object.title : "-"}</p>
                        <p title={object.message ? object.message : ""}>{object.message ? object.message : "-"}</p>
                        <p title={object.sent_by?.full_name ? object.sent_by?.full_name : ""}>{object.sent_by?.full_name ? object.sent_by?.full_name : "-"}</p>
                        <p title={`${object.start_date ?? "N/A"} - ${object.end_date ?? "N/A"}`}>{object.start_date ? object.start_date : "N/A"} - {object.end_date ? object.end_date : "N/A"}</p>
                        <div className={styles.actions}>
                          <HiPencil onClick={() => navigate("/campanhas/"+object.id, {state: {page: currentPage}})} className={styles.icon} size={22}/>
                          <HiTrash className={styles.icon} onClick={() => setDeleteCampaign(<DeleteModal close={setDeleteCampaign} objectId={object.id} objectName={object.title} deleteFunction={getAlertDelete}/>)} size={22}/>
                          <HiBell className={styles.icon} style={{opacity: object.notified ? 0.4 : ""}} title={"Notificar"} size={22} onClick={() => setNotifModal(<Modal id={object.id} closeModal={setNotifModal} setAlert={setAlert} setLoading={setLoading} warningText={object.notified ? `Esta campanha já foi notificada a ${object.notified}` : ""} fetchData={assignData} />)}/>
                        </div>
                      </div>
                    )
                  :
                    <div className={styles.noData}>
                      <p>Não existem dados</p>
                    </div>
                }
              </div>
              {
                previousPage || nextPage ?
                  <div className={styles.arrows}>
                    <TbArrowBigLeftLinesFilled size={28} color={currentPage && currentPage > 1 ? "" : "#00000000"} onClick={() => handlePageChange(true, 1)}/>
                    <TbArrowBigLeftFilled size={28} color={previousPage ? "" : "#00000000"} onClick={() => handlePageChange(false)}/>
                    {currentPage ? currentPage : ""}
                    <TbArrowBigRightFilled size={28} color={nextPage ? "" : "#00000000"} onClick={() => handlePageChange(true)}/>
                    <TbArrowBigRightLinesFilled size={28} color={currentPage !== getLastPage() ? "" : "#00000000"} onClick={() => handlePageChange(true, getLastPage())}/>
                  </div>
                : ""
              }
            </div>
          </div>
        </div>
      }
    </div>
  );
}

export default Campanhas;